import { graphql } from 'react-relay';

export const tradeEnrollmentAndStatusUpdateQuery = graphql`
    query tradeEnrollmentAndStatusUpdateQuery {
        viewer {
            isEnrollmentAndStatusUpdateEnabled: isEnabled(
                key: "enableTradeEnrollmentAndStatusUpdate"
            )
        }
    }
`;
